var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.194,
    height: 18.194,
    viewBox: "0 0 18.194 18.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1,0A9.1,9.1,0,1,1,0,9.1,9.1,9.1,0,0,1,9.1,0",
    fill: "#240ac6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.865,4.21h2.3A1.9,1.9,0,0,1,6.318,6.168,1.733,1.733,0,0,1,5.218,7.9l1.325,2.428H5.306L4.1,8.089H2.975v2.243H1.865ZM4,7.17c.822,0,1.194-.35,1.194-1s-.372-1.031-1.2-1.031H2.975V7.17Z",
    transform: "translate(0.745 1.682)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59,10.571l.975-.237a1.073,1.073,0,0,0,1.069.578c.617,0,1.065-.279,1.065-.954V9.087H8.647a1.366,1.366,0,0,1-1.321.76C6.266,9.847,5.432,9.1,5.432,7.6s.834-2.341,1.9-2.341a1.373,1.373,0,0,1,1.318.82h.059v-.76H9.773V9.989c0,1.174-.915,1.742-2.155,1.742a1.9,1.9,0,0,1-2.028-1.16M8.705,7.6c0-.871-.382-1.447-1.079-1.447-.719,0-1.092.612-1.092,1.447S6.913,9,7.626,9c.691,0,1.079-.526,1.079-1.4",
    transform: "translate(2.17 2.102)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1,7,12.039,5.3h1.143L11.8,7.6l1.408,2.3H12.067L11.1,8.243,10.134,9.9H8.985l1.4-2.3L9.021,5.3h1.148Z",
    transform: "translate(3.59 2.119)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegex);
export default __webpack_public_path__ + "static/media/Regex.574dc90fad9fc52a2ead13ef8955753e.svg";
export { ForwardRef as ReactComponent };